import * as React from "react";

/**
 * Internal dependencies.
 */
import './_chart-progress-bar.scss';


const ProgressBar = ( props ) => {

  // set atom class
  const atomClassName = 'progress';
  var atomClass = props.className != undefined ? atomClassName + ' ' + props.className : atomClassName;
	const pbVal = props.val != undefined ? Number(Math.round(props.val+'e2')+'e-2') : 0;

	const styles = {
		progress : {
		},
		progressBar : {
			width: pbVal+'%',
		},
		progressVal : {
		}
	}
	
  return (
		<div className={ atomClass } style={styles.progress}>
			<div className="progress-bar" role="progressbar" aria-label="Example with label" style={styles.progressBar} aria-valuenow={pbVal} aria-valuemin="0" aria-valuemax="100"></div>
			<div className="progress-val" style={styles.progressVal}>{pbVal.toLocaleString()}%</div>
		</div>
  )
}

export default ProgressBar
